<section>
    <div class="mainFrame">
    <div class="thoughtsHeadline">
        <div class="topRow">
            <div class="arrow"><img src="assets/icon/thoughts/arrowleft.png"></div>
            <div class="words"><p>{{ 'thoughts.words' | translate }}</p></div>
        </div>
        <div class="bottomRow">
            <p>{{ 'thoughts.headline' | translate }}<p>
        </div>
    </div>
    <div class="thoughtsCards">
        <div class="cardOne">
            <div class="cardComment"><p>{{ 'thoughts.cardOneText' | translate }}</p></div>
            <div class="signaturesCard">
                <div>
                    <div class="cardName"><p>{{ 'thoughts.cardOneName' | translate }}</p></div>
                    <div class="fontendDeveloper">{{ 'thoughts.cardOnePosition' | translate }}</div>
                </div>
                <div class="cardNameProfile">
                    <img src="assets/icon/thoughts/inBlack.png">
                    <p onclick="window.location.href='https://www.linkedin.com/in/red-shiba/'">{{ 'thoughts.profile' | translate }}</p>
                </div>
            </div>
        </div>
        <div class="cardTwo">
            <div class="cardComment"><p>{{ 'thoughts.cardTwoText' | translate }}</p></div>
            <div class="signaturesCard">
                <div>
                    <div class="cardName"><p>{{ 'thoughts.cardTwoName' | translate }}</p></div>
                    <div class="fontendDeveloper">{{ 'thoughts.cardTwoPosition' | translate }}</div>
                </div>
                <div class="cardNameProfile">
                    <img src="assets/icon/thoughts/inBlack.png">
                    <p onclick="window.location.href='https://www.linkedin.com/in/dzmitry-stashkevich-3025861b9/'">{{ 'thoughts.profile' | translate }}</p>
                </div>
            </div>
        </div>
        <div class="cardThree">
            <div class="cardComment"><p>{{ 'thoughts.cardThreeText' | translate }}
                </p>
            </div>
            <div class="signaturesCard">
                <div>
                    <div class="cardName"><p>{{ 'thoughts.cardThreeName' | translate }}</p></div>
                    <div class="fontendDeveloper">{{ 'thoughts.cardThreePosition' | translate }}</div>
                </div>
                <div class="cardNameProfile">
                    <img src="assets/icon/thoughts/inBlack.png">
                    <p onclick="window.location.href='https://www.linkedin.com/in/martin-bock-8aa698139'">{{ 'thoughts.profile' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
</section>


